"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Pluralize the given string. If count is given, only pluralize when it is
 * greater than 0.
 *
 * @Param {string} singularString = The string to pluralize.
 * @Param {count} count           = The count of referenced items.
 *
 * @Example
 *
 *   pluralize('banana');
 *   //=> 'bananas'
 *
 *   pluralize('banana', 1);
 *   //=> 'banana'
 *
 *   pluralize('banana', 2);
 *   //=> 'bananas'
 */
function pluralize(singularString, count = 2) {
    if (count <= 1) {
        return singularString;
    }
    if (['s', 'sh', 'ch', 'x', 'z'].some((suffix) => singularString.endsWith(suffix))) {
        return `${singularString}es`;
    }
    return `${singularString}s`;
}
exports.pluralize = pluralize;
//# sourceMappingURL=pluralize.js.map